<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <div class="la-ball-pulse-sync la-dark la-3x">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>